const normalizeSingleBillCode = (code?: string | null) => {
  const normalizedCode = code?.trim().toUpperCase();

  return normalizedCode || null;
};

export const getSingleBillPaymentConfigurationBucket = (countryCode?: string | null) => {
  const country = normalizeSingleBillCode(countryCode);

  switch (country) {
    case 'US':
    case 'CA':
    case 'GB':
    case 'AU':
    case 'NZ':
    case 'IN':
      return country;
    default:
      return country ? 'DEFAULT' : null;
  }
};

export const getSingleBillCurrencyCodeByCountry = (countryCode?: string | null) => {
  switch (normalizeSingleBillCode(countryCode)) {
    case 'CA':
      return 'CAD';
    case 'GB':
      return 'GBP';
    case 'AU':
      return 'AUD';
    case 'NZ':
      return 'NZD';
    case 'IN':
      return 'INR';
    case 'US':
      return 'USD';
    default:
      return undefined;
  }
};

export const getSingleBillPaymentElementConfigurationBucket = (
  countryCode?: string | null,
  currencyCode?: string | null
) => {
  const country = normalizeSingleBillCode(countryCode);
  const currency = normalizeSingleBillCode(currencyCode);

  if (country === 'US' && currency === 'USD') return 'US_USD';

  if (country === 'CA' && currency === 'CAD') return 'CA_CAD';

  if (country === 'GB' && currency === 'GBP') return 'GB_GBP';

  if (country === 'AU' && currency === 'AUD') return 'AU_AUD';

  if (country === 'NZ' && currency === 'NZD') return 'NZ_NZD';

  if (country === 'IN' && currency === 'INR') return 'IN_INR';

  return getSingleBillPaymentConfigurationBucket(countryCode);
};
